import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  spinnerContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  spinner: {
    marginRight: '16px'
  }
});
